import React from 'react';

const OrderComplete = () => {
    return (
        <div>Order Complete page</div>
    )
}

export default OrderComplete;